import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import * as styles from './OptionPlanIndexFrame.module.scss'

import {
  BannerHurusatoNouzeiSmall,
  FacilityOptionPlanPanel,
  MainColumn,
  MultiColumn,
  OptionPlanIndex,
  OptionPlanPanel,
  SearchLayout,
  SearchMainContent,
  SideColumn,
  Text,
} from '../../components'
import { usePropertyProvider } from '../../hooks'

const translateNamespace = 'frames.OptionPlanIndexFrame'

export const OptionPlanIndexFrame = () => {
  const { t } = useTranslation()
  const { isHotel, isActivity } = usePropertyProvider()

  return (
    <SearchLayout>
      <SearchMainContent>
        <MultiColumn>
          <SideColumn>
            {isHotel ? <OptionPlanPanel /> : <FacilityOptionPlanPanel />}
            <div className={styles.optionDesc}>
              <Text size={14}>{t(`${translateNamespace}.optionDesc`)}</Text>
            </div>
            <div className={clsx(styles.bannerArea, 'pc')}>
              {isActivity ? null : <BannerHurusatoNouzeiSmall />}
            </div>
          </SideColumn>
          <MainColumn>
            <OptionPlanIndex />
            <div className={clsx(styles.bannerArea, 'sp')}>
              {isActivity ? null : <BannerHurusatoNouzeiSmall />}
            </div>
          </MainColumn>
        </MultiColumn>
      </SearchMainContent>
    </SearchLayout>
  )
}
